// extracted by mini-css-extract-plugin
export default {"card":"ui_card__VVlXo","columns":"ui_columns__hTijp","column":"ui_column__IyGSe"};